module.exports = __webpack_public_path__ + "static/media/select-top.fddd4a27.svg";